import { render, staticRenderFns } from "./order-table-waiting.vue?vue&type=template&id=208f7b9c"
import script from "./order-table-waiting.vue?vue&type=script&lang=js"
export * from "./order-table-waiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports